/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteRequest
 */
export interface DeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof DeleteRequest
     */
    teamMemberId?: string;
}

export function DeleteRequestFromJSON(json: any): DeleteRequest {
    return DeleteRequestFromJSONTyped(json, false);
}

export function DeleteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'teamMemberId': !exists(json, 'teamMemberId') ? undefined : json['teamMemberId'],
    };
}

export function DeleteRequestToJSON(value?: DeleteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'teamMemberId': value.teamMemberId,
    };
}


